<template>
  <dl class="row border-top border-violeta-claro mt-2 pt-3 mb-1">
    <dt class="col-5 h6 text-morado-claro">RBD</dt>
    <dd class="col-7 h6 pl-2 font-weight-bold text-morado-claro">{{ rbd }}</dd>

    <dt class="col-5 h6 text-morado-claro">Director(a)</dt>
    <dd class="col-7 h6 pl-2 font-weight-bold text-morado-claro">
      {{ director }}
    </dd>

    <dt class="col-5 h6 text-morado-claro">Dependencia</dt>
    <dd class="col-7 pl-2 h6 font-weight-bold text-morado-claro">
      {{ dependencia }}
    </dd>

    <dt class="col-5 h6 text-morado-claro">Niveles</dt>
    <dd class="col-7 pl-2 h6 font-weight-bold text-morado-claro">
      {{ rangoNiveles }}
    </dd>

    <dt v-if="false" class="col-5 h6 text-morado-claro">Enseñanza</dt>
    <dd v-if="false" class="col-7 pl-2 h6 font-weight-bold text-morado-claro">
      {{ ensenianza }}
    </dd>

    <dt class="col-5 h6 text-morado-claro">Orientación Religiosa</dt>
    <dd class="col-7 pl-2 font-weight-bold text-morado-claro">
      {{ orientacionCalculada }}
    </dd>

    <!--<dt class="col-5 h6 text-morado-claro">Uniforme</dt>
    <dd class="col-7 pl-2 font-weight-bold text-morado-claro">{{ uniforme }}</dd>-->
  </dl>
</template>

<script>
export default {
  props: {
    rbd: {
      type: Number,
      required: true
    },
    director: {
      type: String,
      required: true
    },
    dependencia: {
      type: String,
      required: true
    },
    nivelMenor: {
      type: String,
      required: true
    },
    nivelMayor: {
      type: String,
      required: true
    },
    ensenianza: {
      type: String,
      required: true
    },
    orientacion: {
      type: String,
      required: true
    },
    uniforme: {
      type: String,
      required: true
    }
  },
  computed: {
    orientacionCalculada() {
      return this.dependencia === "Particular subvencionado"
        ? this.orientacion
        : "Laica";
    },
    rangoNiveles() {
      if (this.nivelMenor == this.nivelMayor) {
        return this.nivelMenor;
      }
      return this.nivelMenor + " - " + this.nivelMayor;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/izquierda/CartaDatos.vue